import { c as _c } from "react/compiler-runtime";
import useCartIsContactFormDisabled from '@/contexts/cartContext/hooks/useCartIsContactFormDisabled';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { FFormIdEnum } from '@/types/form';
import EmailForm from './EmailForm';
import FirstNameForm from './FirstNameForm';
import LastNameForm from './LastNameForm';
import PhoneForm from './PhoneForm';
const ContactInfoForm = () => {
    const $ = _c(15);
    const translate = useTranslate();
    let t0;
    if ($[0] !== translate) {
        t0 = translate("form.info.email_and_phone_reason");
        $[0] = translate;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    const emailAndPhoneReason = t0;
    const isContactFormDisabled = useCartIsContactFormDisabled();
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[2] !== isContactFormDisabled) {
        t1 = <FirstNameForm formId={FFormIdEnum.CART_VALIDATION} disabled={isContactFormDisabled}/>;
        t2 = <LastNameForm formId={FFormIdEnum.CART_VALIDATION} disabled={isContactFormDisabled}/>;
        t3 = <EmailForm formId={FFormIdEnum.CART_VALIDATION} disabled={isContactFormDisabled}/>;
        t4 = <PhoneForm formId={FFormIdEnum.CART_VALIDATION} disabled={isContactFormDisabled}/>;
        $[2] = isContactFormDisabled;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    }
    else {
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== emailAndPhoneReason) {
        t5 = <p className="text-xs text-gray-400 xs:col-span-2">{emailAndPhoneReason}</p>;
        $[7] = emailAndPhoneReason;
        $[8] = t5;
    }
    else {
        t5 = $[8];
    }
    let t6;
    if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
        t6 = <><fieldset className="grid grid-cols-1 gap-y-4 xs:grid-cols-2 xs:gap-x-6 mb-8">{t1}{t2}{t3}{t4}{t5}
      </fieldset></>;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    }
    else {
        t6 = $[14];
    }
    return t6;
};
export default ContactInfoForm;
